export const HELP_CENTRE_URL: string =
  "https://help.editor.raspberrypi.org/hc/en-us";

export const SSO_FOR_STUDENTS_HELP_ARTICLE_URL: string = `${HELP_CENTRE_URL}/articles/51453036060948-How-to-Set-up-SSO-for-Students/`;

export const CODE_CLASSROOM_HELP_CATEGORY_URL: string = `${HELP_CENTRE_URL}/categories/115000275003-Code-Classroom`;

export const WHAT_DOES_BETA_MEAN_HELP_ARTICLE_URL: string = `${HELP_CENTRE_URL}/articles/29332709184276-What-does-beta-mean`;

export const NEW_RELEASES_HELP_ARTICLE_URL: string = `${HELP_CENTRE_URL}/articles/31701267547412-New-releases`;
